import { ClientLambdaApi } from '@/api-client.js'

import {
  ActivationPostModel,
  ActivationItemIndexModel,
  ActivationDetailModel

} from '@/app/activations/models/Index.js'

const getProducts = async (searchQuery) => {
  const products = await ClientLambdaApi.get(`/activations/products?query=${searchQuery}`)
  return products.data
}

const getActivations = async () => {
  const activations = await ClientLambdaApi.get('/activations')
  return activations.data.map(rawActivation => new ActivationItemIndexModel(rawActivation))
}

const getActivation = async (activationId) => {
  const activation = await ClientLambdaApi.get('/activations/' + activationId)
  return new ActivationDetailModel(activation.data)
}

const postActivation = async (newActivation) => {
  const addedActivation = await ClientLambdaApi.post('/activations', {
    new_activation: new ActivationPostModel(newActivation)
  })
  return addedActivation.data
}

export {
  getProducts,
  postActivation,
  getActivations,
  getActivation
}



// WEBPACK FOOTER //
// ./src/app/activations/Services.js